export default "__VITE_ASSET__CityScOc__"